<template>
  <div class="discovery-display-rows light-striped-parent" ref="display">
    <rows-item
      v-for="item in search.data.BibSearchRows"
      v-bind:key="item.position"
      :item="item"
    />
  </div>
</template>

<script>
import RowsItem from '@/components/displays/RowsItem.vue';

export default {
  name: 'RowsDisplay',
  components: {
    RowsItem,
  },
  props: {
    search: Object,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="less">
@import '~@/css/global';

</style>
